import React from 'react';
import { compose } from '../../reactApolloCompat';
import withStyles from '@mui/styles/withStyles';
import { withSnackbarMessage } from '../../context/SnackbarMessage';
import { getUser } from '../../utils/sessions';
import { getMyClient } from '../../utils/apollo';
import WorkQueueView from '../../components/workQueue/WorkQueueView';
import ErrorFallback from '../../components/ErrorFallback';
import { withErrorBoundary } from '@sentry/react';

function WorkQueue(props) {
    return (
        <div className="workqueue-page">
            <WorkQueueView client={getMyClient} user={getUser()} props={props} />
        </div>
    );
}

export default withErrorBoundary(compose(withSnackbarMessage, withStyles({}))(WorkQueue), { fallback: ErrorFallback });
